import { render, staticRenderFns } from "./ed-images-viewer.vue?vue&type=template&id=4b9280b4&scoped=true&"
import script from "./ed-images-viewer.ts?vue&type=script&lang=js&"
export * from "./ed-images-viewer.ts?vue&type=script&lang=js&"
import style0 from "./ed-images-viewer.scss?vue&type=style&index=0&id=4b9280b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9280b4",
  null
  
)

export default component.exports